<template>
  <table class="table">
    <tr class="tr">
      <td>Is this Vehicle registered under the applicant now ?</td>
      <td  :class="{'green-tip':handleCompare('already_owned_by_ind')}">
        <!-- {{ formData.rgtn_no }} -->
        <alt-copy
          key_value="already_owned_by_ind"
          :text="getOptionName('yesNoOptions', formData.already_owned_by_ind)"
          :copyKey="copyKey"
          className="key-alt-down"
          @sendKey="getKey"></alt-copy>
      </td>
    </tr>
    <tr
      class="tr">
      <td>Registration Mark</td>
      <td  :class="{'green-tip':handleCompare('rgtn_no')}">
        <!-- {{ formData.rgtn_no }} -->
        <alt-copy
          key_value="rgtn_no"
          :text="formData.rgtn_no"
          :copyKey="copyKey"
          className="key-alt-down"
          @sendKey="getKey"></alt-copy>
      </td>
    </tr>
    <tr class="tr">
      <td>Coverage</td>
      <td  :class="{'green-tip':handleCompare('trm_of_cvr')}">
        <!-- {{getOptionName('allCoverTypeOptions', formData.trm_of_cvr)  }} -->
        <alt-copy
          key_value="trm_of_cvr"
          :text="getOptionName('allCoverTypeOptions', formData.trm_of_cvr)"
          :copyKey="copyKey"
          className="key-alt-down"
          @sendKey="getKey"></alt-copy>
      </td>
    </tr>
    <tr
      v-if="formData.trm_of_cvr!==1"
      class="tr">
      <td>Vehicle Market Value (Sum Insured)</td>
      <td  :class="{'green-tip':handleCompare('isrd_vl')}">
        <!-- {{  formData.isrd_vl|formatMoney(2, true) }} -->
        <alt-copy
          key_value="isrd_vl"
          :text="formData.isrd_vl|formatMoney(2, true)"
          :copyKey="copyKey"
          className="key-alt-down"
          @sendKey="getKey"></alt-copy>
      </td>
    </tr>
    <tr class="tr">
      <td>Make</td>
      <td  :class="{'green-tip':handleCompare('brand_id')}">
        <!-- {{ getLocalAllOptionName('brand', formData.brand_id) }} -->
        <alt-copy
          key_value="brand"
          :text="formData.brand"
          :copyKey="copyKey"
          className="key-alt-down"
          @sendKey="getKey"></alt-copy>
      </td>
    </tr>
    <template v-if="classId == 11">
      <tr
        class="tr">
        <td>Model</td>
        <!--      <span>{{ getOptionName('carModelOptions', formData.model_id) }}</span>-->
        <td  :class="{'green-tip':handleCompare('model')}">
          <!-- {{ formData.model }} -->
          <alt-copy
            key_value="model"
            :text="formData.model"
            :copyKey="copyKey"
            className="key-alt-down"
            @sendKey="getKey"></alt-copy>
        </td>
      </tr>
      <tr
        class="tr">
        <td>Model Name</td>
        <!--      <span>{{ getOptionName('carModelOptions', formData.model_id) }}</span>-->
        <td  :class="{'green-tip':handleCompare('rgtn_mdl')}">
          <!-- {{ formData.model }} -->
          <alt-copy
            key_value="rgtn_mdl"
            :text="formData.rgtn_mdl"
            :copyKey="copyKey"
            className="key-alt-down"
            @sendKey="getKey"></alt-copy>
        </td>
      </tr>
    </template>
    <tr
      v-else
      class="tr">
      <td>Model</td>
      <!--      <span>{{ formData.model }}</span>-->
      <td  :class="{'green-tip':handleCompare('rgtn_mdl')}">
        <!-- {{ formData.rgtn_mdl }} -->
        <alt-copy
          key_value="rgtn_mdl"
          :text="formData.rgtn_mdl"
          :copyKey="copyKey"
          className="key-alt-down"
          @sendKey="getKey"></alt-copy>
      </td>
    </tr>
    <tr class="tr">
      <td>Body Type</td>
      <td  :class="{'green-tip':handleCompare('typ_of_bdy_id')}">
        <!-- {{ getLocalAllOptionName('typ_of_bdy', formData.typ_of_bdy_id) }} -->
        <alt-copy
          key_value="typ_of_bdy_id"
          :text="getLocalAllOptionName('typ_of_bdy', formData.typ_of_bdy_id)"
          :copyKey="copyKey"
          className="key-alt-down"
          @sendKey="getKey"></alt-copy>
      </td>
      <!--        <span v-if="classId == 12">{{ getLocalAllOptionName('typ_of_bdy', formData.rgtn_typ_of_bdy) }}</span>-->
    </tr>
    <tr class="tr">
      <td>Year of Manufacture</td>
      <td  :class="{'green-tip':handleCompare('rgtn_yr')}">
        <!-- {{ getLocalAllOptionName('rgtn_yr', formData.rgtn_yr) }} -->
        <alt-copy
          key_value="rgtn_yr"
          :text="getLocalAllOptionName('rgtn_yr', formData.rgtn_yr)"
          :copyKey="copyKey"
          className="key-alt-down"
          @sendKey="getKey"></alt-copy>
      </td>
    </tr>
    <tr
      v-if="!isElectricCar11"
      class="tr">
      <td>Cylinder Capacity</td>
      <td  :class="{'green-tip':handleCompare('engn_cpcty')}">
        <!-- {{ formData.engn_cpcty||0 }} cc -->
        <alt-copy
          key_value="engn_cpcty"
          :text1="formData.engn_cpcty||0"
          connector=" "
          text="cc"
          :copyKey="copyKey"
          className="key-alt-down"
          @sendKey="getKey"></alt-copy>
      </td>
    </tr>
    <template v-if="classId == 12">
      <tr
        class="tr">
        <td>Permitted Gross Vehicle Weight</td>
        <td  :class="{'green-tip':handleCompare('tonnage')}">
          <!-- {{ formData.tonnage }} -->
          <alt-copy
            key_value="tonnage"
            :text="formData.tonnage"
            :copyKey="copyKey"
            className="key-alt-down"
            @sendKey="getKey"></alt-copy>
        </td>
      </tr>
    </template>
    <tr class="tr">
      <td>Seating Capacity ( excl. driver)</td>
      <td :class="{'green-tip':handleCompare('no_of_seats')}">
        <!-- {{ formData.no_of_seats }} -->
        <alt-copy
          key_value="no_of_seats"
          :text="formData.no_of_seats"
          :copyKey="copyKey"
          className="key-alt-down"
          @sendKey="getKey"></alt-copy>
      </td>
    </tr>
    <tr class="tr">
      <td>Chassis Number</td>
      <td :class="{'green-tip':handleCompare('chasis_no')}">
        <!-- {{ formData.chasis_no }} -->
        <alt-copy
          key_value="chasis_no"
          :text="formData.chasis_no"
          :copyKey="copyKey"
          className="key-alt-down"
          @sendKey="getKey"></alt-copy>
      </td>
    </tr>
    <tr class="tr">
      <td>Engine Number</td>
      <td :class="{'green-tip':handleCompare('engn_no')}">
        <!-- {{ formData.engn_no }} -->
        <alt-copy
          key_value="engn_no"
          :text="formData.engn_no"
          :copyKey="copyKey"
          className="key-alt-down"
          @sendKey="getKey"></alt-copy>
      </td>
    </tr>
    <tr class="tr">
      <td>NCD</td>
      <td  :class="{'green-tip':handleCompare('ncd_pct')}">
        <!-- {{ getLocalAllOptionName('ncd', formData.ncd_pct) }} -->
        <alt-copy
          key_value="ncd_pct"
          :text="getLocalAllOptionName('ncd', formData.ncd_pct)"
          :copyKey="copyKey"
          className="key-alt-down"
          @sendKey="getKey"></alt-copy>
      </td>
    </tr>
    <div v-if="formData.ncd_pct>0">
      <tr class="tr">
        <td>Previous Insurance Company</td>
        <td :class="{'green-tip':handleCompare('prev_insurer_nm_language')}">
          <!-- {{ getLocalAllOptionName('latest_insurance_company', formData.prev_insurer_nm) }} -->
          <alt-copy
            key_value="prev_insurer_nm"
            :text="formData.prev_insurer_nm_language"
            :copyKey="copyKey"
            className="key-alt-down"
            @sendKey="getKey"></alt-copy>
        </td>
      </tr>
      <tr class="tr">
        <td>Previous Registration Number</td>
        <td :class="{'green-tip':handleCompare('prev_rgtn_no')}">
          <!-- {{ formData.prev_rgtn_no }} -->
          <alt-copy
            key_value="prev_rgtn_no"
            :text="formData.prev_rgtn_no"
            :copyKey="copyKey"
            className="key-alt-down"
            @sendKey="getKey"></alt-copy>
        </td>
      </tr>
      <tr class="tr">
        <td>Previous Policy Number</td>
        <td  :class="{'green-tip':handleCompare('prev_pcy_no')}">
          <!-- {{formData.prev_pcy_no }} -->
          <alt-copy
            key_value="prev_pcy_no"
            :text="formData.prev_pcy_no"
            :copyKey="copyKey"
            className="key-alt-down"
            @sendKey="getKey"></alt-copy>
        </td>
      </tr>
      <tr
        class="tr">
        <td>Is the subject Insured vehicle be the same as the one under the previous policy?</td>
        <td :class="{'green-tip':handleCompare('is_same_car')}">
          <!-- {{ getOptionName('yesNoOptions',formData.is_same_car) }} -->
          <alt-copy
            key_value="is_same_car"
            :text="getOptionName('yesNoOptions',formData.is_same_car)"
            :copyKey="copyKey"
            className="key-alt-down"
            @sendKey="getKey"></alt-copy>
        </td>
      </tr>
      <!--      <div-->
      <!--        v-if="showAgreeQusetion"-->
      <!--        class="tr">-->
      <!--        <span>As you are the existing client of the selected insurance company, due to the administration requirement, you agree to appoint HoldCover Insurance Brokers Limited to handle the insurance matter with immediate effect, and understand that the policy documents will be ready in 3-5 working days.</span>-->
      <!--        <span :class="{'green-tip':handleCompare('is_agree_handle')}">-->
      <!--          &lt;!&ndash; {{ getOptionName('yesNoOptions',formData.is_same_car) }} &ndash;&gt;-->
      <!--          <alt-copy-->
      <!--            key_value="is_same_car"-->
      <!--            :text="getOptionName('agreeOptions',formData.is_agree_handle)"-->
      <!--            :copyKey="copyKey"-->
      <!--            className="key-alt-down"-->
      <!--            @sendKey="getKey"></alt-copy>-->
      <!--        </span>-->
      <!--      </div>-->
    </div>
    <template v-if="classId != 12">
      <tr
        v-if="classId==14"
        class="tr">
        <td>Will the vehicle be used for commercial purpose?</td>
        <td :class="{'green-tip':handleCompare('usage_ind')}">
          <!-- {{ getAllOptionName('mc_usage', formData.usage_ind) }} -->
          <alt-copy
            key_value="usage_ind"
            :text="getAllOptionName('mc_usage', formData.usage_ind)"
            :copyKey="copyKey"
            className="key-alt-down"
            @sendKey="getKey"></alt-copy>
        </td>
      </tr>
      <tr
        v-else
        class="tr">
        <td>Car Usage</td>
        <td :class="{'green-tip':handleCompare('usage_ind')}">
          <!-- {{ getOptionName('usageOptions', formData.usage_ind) }} -->
          <alt-copy
            key_value="usage_ind"
            :text="getOptionName('usageOptions', formData.usage_ind)"
            :copyKey="copyKey"
            className="key-alt-down"
            @sendKey="getKey"></alt-copy>
        </td>
      </tr>
      <tr
        v-if="formData.usage_ind==2&&classId!=14"
        class="tr">
        <td> What kind of commercial usage</td>
        <td
          v-if="businessPurposes.length > 0"
          class="child-span-block">
          <span
            v-for="(item, index) in businessPurposes"
            :key="index"
            :class="{'green-tip':handleCompare('business_purposes')}">
            <!-- {{ item.name }} -->
            <alt-copy
              :key_value="'business_purposes'+index"
              :text="item.name"
              :copyKey="copyKey"
              className="key-alt-down"
              @sendKey="getKey"></alt-copy>
          </span>
        </td>
        <span v-else>None</span>
      </tr>
    </template>
    <tr
      v-if="classId == 12"
      class="tr">
      <td>Will the vehicle be used by third party for carrying goods for reward?</td>
      <td :class="{'green-tip':handleCompare('use_carrying_profit_ind')}">
        <!-- {{ getOptionName('yesNoOptions', formData.use_carrying_profit_ind) }} -->
        <alt-copy
          key_value="use_carrying_profit_ind"
          :text="getOptionName('yesNoOptions', formData.use_carrying_profit_ind)"
          :copyKey="copyKey"
          className="key-alt-down"
          @sendKey="getKey"></alt-copy>
      </td>
    </tr>
    <tr class="tr">
      <td>Is there any modification in the above vehicle?</td>
      <td :class="{'green-tip':handleCompare('car_modified_ind')}">
        <!-- {{ getOptionName('modifiedOptions', formData.car_modified_ind) }} -->
        <alt-copy
          key_value="car_modified_ind"
          :text="getOptionName('modifiedOptions', formData.car_modified_ind)"
          :copyKey="copyKey"
          className="key-alt-down"
          @sendKey="getKey"></alt-copy>
      </td>
    </tr>
    <tr class="tr">
      <td>Is the vehicle fitted with Car Camcorder?</td>
      <td :class="{'green-tip':handleCompare('car_camcorder_ind')}">
        <!-- {{ getOptionName('installOptions', formData.car_camcorder_ind) }} -->
        <alt-copy
          key_value="car_camcorder_ind"
          :text="getOptionName('installOptions', formData.car_camcorder_ind)"
          :copyKey="copyKey"
          className="key-alt-down"
          @sendKey="getKey"></alt-copy>
      </td>
    </tr>
    <tr
      v-if="classId != 14"
      class="tr">
      <td>Alarm and / or Global Positioning System should be installed?</td>
      <td :class="{'green-tip':handleCompare('alarm_or_global_ind')}">
        <!-- {{ getOptionName('installOptions', formData.alarm_or_global_ind) }} -->
        <alt-copy
          key_value="alarm_or_global_ind"
          :text="getOptionName('installOptions', formData.alarm_or_global_ind)"
          :copyKey="copyKey"
          className="key-alt-down"
          @sendKey="getKey"></alt-copy>
      </td>
    </tr>
    <tr
      v-if="formData.no_acci_nor_deduct==0"
      class="tr">
      <td>Are all the driver(s) has not been involved in a motor accident nor deduction of driving offence over 5 points in the past three years?</td>
      <td  :class="{'green-tip':handleCompare('no_acci_nor_deduct')}">
        <!-- {{ getOptionName('yesNoOptions', formData.no_acci_nor_deduct) }} -->
        <alt-copy
          key_value="no_acci_nor_deduct"
          :text="getOptionName('yesNoOptions', formData.no_acci_nor_deduct)"
          :copyKey="copyKey"
          className="key-alt-down"
          @sendKey="getKey"></alt-copy>
      </td>
    </tr>
    <tr
      v-if="formData.no_acci_nor_deduct!=0"
      class="tr">
      <td>Are all the driver(s) has not been involved in a motor accident in the past 3 years?</td>
      <td :class="{'green-tip':handleCompare('no_dr_acci_ind')}">
        <!-- {{ getOptionName('acciOptions', formData.no_dr_acci_ind) }} -->
        <alt-copy
          key_value="no_dr_acci_ind"
          :text="getOptionName('acciOptions', formData.no_dr_acci_ind)"
          :copyKey="copyKey"
          className="key-alt-down"
          @sendKey="getKey"></alt-copy>
      </td>
    </tr>
    <tr
      v-if="formData.no_acci_nor_deduct!=0"
      class="tr">
      <td v-if="formData.class_id==11">Are all the driver(s) has not been deducted driving offence points in the past 3 years? </td>
      <td v-else>Are all the driver(s) has not been deducted driving offence points in the past 3 years? </td>
      <td  :class="{'green-tip':handleCompare('no_dr_deduct_ind')}">
        <!-- {{ getOptionName('deductOptions', formData.no_dr_deduct_ind) }} -->
        <alt-copy
          key_value="no_dr_deduct_ind"
          :text="getOptionName('deductOptions', formData.no_dr_deduct_ind)"
          :copyKey="copyKey"
          className="key-alt-down"
          @sendKey="getKey"></alt-copy>
      </td>
    </tr>
  </table>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import {mapActions, mapState} from 'vuex'

export default {
  name: 'InsuredVehicleInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    compareList: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      formData: {},
      copyKey: ''
    }
  },
  computed: {
    ...mapState('quote', ['carModelOptions']),
    showAgreeQusetion(){
      let {company_id} = this.form
      let {prev_insurer_nm,is_same_car} = this.formData||{}
      return this.isShowQuestion&&is_same_car==1
    },
    isShowQuestion(){
      let {prev_insurer_nm,company_id} = this.formData||{}
      let pre_insurance = this.globalOptions.latest_insurance_company||[]
      pre_insurance =pre_insurance.filter(item=> item.id == prev_insurer_nm)
      if(pre_insurance.length>0)
      {
        return  pre_insurance[0].hc_cp_id==company_id
      }else
        return false
    },
    classId() {
      return this.formData.class_id || 14
    },
    localAllOptions() {
      if(this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`]
      }
    },
    businessPurposes() {
      if(!this.localAllOptions || !this.localAllOptions.business_purposes || !this.formData.business_purposes) {
        return []
      }
      return this.localAllOptions.business_purposes.filter(item => {
        return this.formData.business_purposes.includes(item.id)
      })
    },
    isElectricCar11() {
      // 電動車，避免跟之前特斯拉脫機衝突
      const { model_id } = this.formData||{}
      if(model_id) {
        const data = this.getOptionData('', model_id, this.carModelOptions)
        const { is_electric_car } = data || {}
        return is_electric_car == 1
      }
      return false
    },
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        this.formData = val
      }
    },
    'formData.brand_id': {
      immediate: true,
      deep: true,
      handler(val, old) {
        if(val && this.classId == 11) {
          this.updateCarModelOptions({
            val,
            time: new Date().getTime()
          })
        }
      }
    }
  },
  methods: {
    ...mapActions('quote', ['updateCarModelOptions']),
    handleCompare(filed){
      let {type} = this.formData
      if(type!=50) return false
      return  this.compareList.includes(filed)?true:false
    },
    getLocalAllOptionName(target, value) {
      if(this.classId == 14) {
        return this.getAllOptionName(target, value)
      } else {
        return this[`getAllOptionName${this.classId}`](target, value)
      }
    },
    getKey(key){
      this.copyKey = key
    },
  }
}
</script>
